import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Navigate from "../../../components/Navigate/Navigate";
import SideMenuOffices from "../../../components/layout/SideMenuOffices";
import loadingImg from "../../../img/imgLoader.gif";
import Spinner from "../../../components/common/Spinner";
import Btn from "../../../components/common/Btn";
import Input from "../../../components/common/Input";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

import { uploadOfficePhoto, updateOffice } from "../../../actions/officeActions";
import { clearErrors } from "../../../actions/errorsActions";
import { getOffice } from "../../../actions/officeActions";
import successToast from "../../../components/toast/successToast";
import failToast from "../../../components/toast/failToast";
import { roles } from "../../../enums/roles";
import imgPlaceholder from "../../../img/noImg.png";
import OfficeValidation from "../../../validation/OfficeValidation";
import isEmpty from "../../../validation/isEmpty";

import { accountType } from "../../../enums/accountType";

class AdminOffice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: null,
      crop: {
        unit: "%",
        width: 50,
        aspect: 10 / 10,
      },
      super_admin_switch: false,
      global_viewer_switch: false,
      active_switch: false,
      user: {},
      office: this.props.offices && this.props.offices.office,
      mounted: false,
      auth: {},
      uplading: false,
      file: null,
      fileCv: null,
      uploadingCv: false,
      active: false,
      errors: {},
    };
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onFormSubmitEdit = this.onFormSubmitEdit.bind(this);
    this.onChangePhoto = this.onChangePhoto.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let update = {};
    if (nextProps.auth) {
      var tokenUserOffices = nextProps.auth.user.offices;
      update.singleOffice = tokenUserOffices && tokenUserOffices.length === 1 ? true : false;
      if (nextProps.auth !== prevState.auth) {
        if (!nextProps.auth.isAuthenticated || !accountType.USER) {
          nextProps.history.push("/");
        }
        if (
          (nextProps.auth.user.offices &&
            nextProps.auth.user.offices[0] &&
            nextProps.auth.user.offices[0].user_role_office.role.value !== roles.SUPERADMINISTRATOR) ||
          isEmpty(nextProps.auth.user.offices)
        ) {
          nextProps.history.push("/");
        }

        if (nextProps.errors) {
          update.errors = nextProps.errors;
        }
        update.auth = nextProps.auth;
      }

      if (nextProps.offices.office !== prevState.office) {
        var office = nextProps.offices.office;
        update.value = office.value;
        update.short_text = office.short_text;
        update.image = office.image;
        update.office = office;
        update.mappedOffice = office;
        update.officeUpdated = true;
      }
    }
    return Object.keys(update).length ? update : null;
  }

  componentDidMount() {
    this.IsMounted = true;
    this.props.getOffice(this.props.match.params.officeId, () => {});
  }
  componentWillUnmount() {
    this.IsMounted = false;
    this.props.clearErrors();
  }

  onChangePhoto(e) {
    this.setState({ file: e.target.files[0] }, () => {
      this.onFormSubmit(e);
    });
  }

  checkValidation() {
    this.setState({ errors: {} });
    this.props.clearErrors();
    var formData = {};

    formData.value = this.state.value ? this.state.value : null;
    formData.short_text = this.state.short_text ? this.state.short_text.toUpperCase() : null;

    const { errors } = OfficeValidation(formData);
    this.setState({ errors });
  }

  onFormSubmitEdit(e) {
    this.setState({ errors: {}, submitPressed: true });
    e.preventDefault();
    var formData = {};

    formData.value = this.state.value ? this.state.value : null;
    formData.short_text = this.state.short_text ? this.state.short_text.toUpperCase() : null;

    const { errors, isValid } = OfficeValidation(formData);
    if (isValid) {
      this.props.updateOffice(this.props.match.params.officeId, formData, (res) => {
        if (res.status === 200) {
          successToast("Office updated successfully");
          this.props.history.push(`/admin/offices/settings`);
        } else {
          failToast("Office updating failed");
          this.props.history.push(`/admin/offices/office/${this.props.match.params.officeId}/settings`);
        }
      });
    } else {
      this.setState({ errors });
    }
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.setState({ uploading: true });
    const formData = new FormData();
    formData.append("file", this.state.file);
    const config = {
      headers: {
        "content-type": "image/xyz",
      },
    };

    this.props.uploadOfficePhoto(this.props.match.params.officeId, formData, config, (res) => {
      if (res.status === 200) {
        successToast("Photo successfully uploaded");
        this.props.getOffice(this.props.match.params.officeId, () => {
          if (this.IsMounted) {
            this.setState({
              uploading: false,
              src: null,
              croppedImageUrl: null,
              crop: {
                unit: "%",
                width: 100,
                aspect: 10 / 10,
              },
            });
          }
        });
      } else if (res.status === undefined) {
        failToast(`Photo upload failed! Try different format or smaller image`);
        if (this.IsMounted) {
          this.setState({ uploading: false });
        }
      }
      if (this.IsMounted) {
        this.setState({ uploading: false });
      }
    });
  }

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({
          src: reader.result,
          crop: {
            unit: "%",
            width: 100,
            aspect: 10 / 10,
          },
        })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    this.setState({ crop: percentCrop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, "newFile.jpeg");
      this.setState({ croppedImageUrl }, () => {});
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);

        function blobToFile(theBlob, fileName) {
          theBlob.lastModifiedDate = new Date();
          theBlob.name = fileName;
          return theBlob;
        }
        var newFile = blobToFile(blob, "name.png");

        var newfile = new File([newFile], "name.png", { type: "image/png" });
        this.setState({ file: newfile });
        resolve(this.fileUrl);
      }, "image/jpeg");
    });
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.checkValidation();
    });
  }

  render() {
    const { loading } = this.props.offices;
    const { crop, src } = this.state;

    var content;
    var officeImage = "";
    if (this.state.image === null) {
      officeImage = imgPlaceholder;
    } else {
      officeImage = this.state.image;
    }

    var rightContent;
    if (this.state.src === null) {
      rightContent = (
        <div className="candidate-top-right">
          <div className="candidate-top-right--item">
            {/* <div className='candidate-top-right--item-title'>Name:</div> */}
            <div className="candidate-top-right--item-value">
              <Input
                placeholder={"Name"}
                type="text"
                value={this.state.value}
                onChange={(e) => this.onChange(e)}
                name={"value"}
                label="Name"
                validationMsg={[this.state.errors.value, this.props.errors.value]}
              />
              <Input
                placeholder={"Short"}
                type="text"
                value={this.state.short_text}
                onChange={(e) => this.onChange(e)}
                name={"short_text"}
                label="Short"
                validationMsg={[this.state.errors.short_text, this.props.errors.short_text]}
              />
              <Btn label={"Edit"} className="btn btn-primary" onClick={this.onFormSubmitEdit} />
            </div>
          </div>
        </div>
      );
    } else {
      rightContent = (
        <div className="candidate-top-right">
          <div className="upload-image-container">
            <div className="upload-image-container-img">
              <ReactCrop
                src={src}
                crop={crop}
                ruleOfThirds
                onImageLoaded={this.onImageLoaded}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
              />
            </div>
            <div className="upload-image-container-btns">
              <Btn
                label={"Cancel"}
                className="btn btn-secondary"
                onClick={() =>
                  this.setState({
                    src: null,
                    croppedImageUrl: null,
                    crop: {
                      unit: "%",
                      width: 100,
                      aspect: 10 / 10,
                    },
                  })
                }
              />
              <Btn label={"Upload"} className="btn btn-primary" onClick={this.onFormSubmit} />
            </div>
          </div>
        </div>
      );
    }

    if (!this.state.officeUpdated || loading) {
      content = <Spinner />;
    } else {
      var imgContent = "";
      if (this.state.uploading) {
        imgContent = (
          <div>
            <img src={loadingImg} style={{ width: "250px", margin: "auto", display: "block" }} alt="Loading..." />
          </div>
        );
      } else {
        imgContent = (
          <img
            className="card-img-top rounded-circle img-upload"
            src={this.state.croppedImageUrl ? this.state.croppedImageUrl : officeImage}
            alt=""
            onError={(e) => {
              e.preventDefault();
              e.target.onerror = null;
              e.target.src = imgPlaceholder;
            }}
          />
        );
      }

      content = (
        <div className="candidate width-container">
          <div className="candidate-top">
            <div className="candidate-top-left">
              <div className="candidate-top-left-img">
                <form onSubmit={this.onFormSubmit}>
                  <div className="fixed-ratio-div">
                    <label className="rounded-circle">
                      <input
                        className="centered-image rounded-circle"
                        type="file"
                        accept=".gif,.jpg,.jpeg,.png,.tiff,.webp"
                        name="image"
                        onChange={this.onSelectFile}
                        value={""}
                      />
                      {imgContent}
                    </label>
                  </div>
                </form>
              </div>
            </div>
            {rightContent}
          </div>
          <hr />
        </div>
      );
    }

    return (
      <div className="grid-menu-container">
        <div className="menu-grid">
          <div className="menu">
            <SideMenuOffices props={this.props} />
            <hr />
          </div>
        </div>
        <div className="main-grid">
          <div className="main">
            <div className="width-container">
              <Navigate title={"Office"} link={`/admin/offices/global-settings`} />
              {content}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AdminOffice.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  offices: state.offices,
});

export default connect(mapStateToProps, {
  getOffice,
  updateOffice,
  uploadOfficePhoto,
  clearErrors,
})(withRouter(AdminOffice));
